import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import Alert from 'product_tabs/alerts/components/alert';
import Fabrication from './pcb_fabrication/Fabrication';
import Stencil from 'product_tabs/tab_smt_stencils/Stencil';
import Assembly from 'product_tabs/tab_assembly/Assembly';
import Parts from 'product_tabs/tab_parts/Parts';
import Accessories from 'product_tabs/tab_accessories/Accessories';
import Project from './project/Project';

import { changeTab } from 'product_tabs/tabs/tabSlice';
import { changeGlobalParameter } from 'product_tabs/actions';
import { processTabChange as processTabChangeForParts } from 'product_tabs/tab_parts/slice/process_tab_change';

import { TAB_STENCILS, TAB_FABRICATION, TAB_PCB_PARTS, TAB_ACCESORIES, TAB_ASSEMBLY } from 'product_tabs/tabs/data/tabType';

const App = () => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector((state) => state.tab);

  const zip_file_input_id = 'gerber-file'
  const fabrication_slug = 'usa_quickturn_pcb'

  useEffect(() => {
    dispatch(changeGlobalParameter({name: 'zip_input_id', value: zip_file_input_id}))
    dispatch(changeGlobalParameter({name: 'fabrication_slug', value: fabrication_slug}))
  }, []);

  const onChangeTab = (key) => {
    dispatch(changeTab(key))
    dispatch(processTabChangeForParts(key))
  };

  return (
    <>
      <Alert />
      <div className="container">
        <Project />
      </div>
      <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={onChangeTab} defaultActiveKey={TAB_FABRICATION}>
        <div className="container tab-container">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey={TAB_FABRICATION}>PCB Fabrication</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={TAB_ASSEMBLY}>PCB Assembly</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={TAB_PCB_PARTS}>Electronic Components</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={TAB_STENCILS}>SMT Stencils (30% Off)</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={TAB_ACCESORIES}>Accessories</Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <div className="tab-content-wrap">
          <div className="container">
            <Tab.Content>
              <Tab.Pane eventKey={TAB_FABRICATION}>
                <div className="pcb-fabrication">
                  <Fabrication />
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey={TAB_ASSEMBLY}>
                <div className="pcb-assembly">
                  <Assembly />
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey={TAB_PCB_PARTS}>
                <div className="pcb-parts">
                  <Parts />
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey={TAB_STENCILS}>
                <div className="stencils">
                  <Stencil />
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey={TAB_ACCESORIES}>
                <div className="accessories">
                  <Accessories />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </div>
      </Tab.Container>
    </>
  )
}

// export default hot(App);
export default App;
